import { Suspense } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { FeatureFlagGuard } from './guards/FeatureFlagGuard';

export const Spinner = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
    <CircularProgress />
  </Box>
);

// Envuelve una page con Suspense + opcionalmente FeatureFlagGuard.
export function withFlag(flagKey: string | null, element: React.ReactNode) {
  const wrapped = <Suspense fallback={<Spinner />}>{element}</Suspense>;
  if (!flagKey) return wrapped;
  return <FeatureFlagGuard flagKey={flagKey}>{wrapped}</FeatureFlagGuard>;
}

// Catch-all reutilizable.
export const notFoundRoute: RouteObject = { path: '*', element: <Navigate to="/" replace /> };
